import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import i18next from "i18next";
import memoizeOne from "memoize-one";

import { Month } from "api/generated/model";
import { GenericMultiCheckboxes } from "org/control/list/controls/common/genericMultiCheckboxes";

type OnChangeCallback = (key: Month, value: boolean) => void;

interface CommonProps {
    months: Record<Month, boolean[]>;
}
type EditProps = CommonProps & { onChange: OnChangeCallback };
type ReadOnlyProps = CommonProps;
type MultiMonthCheckboxesProps =
    | ({ type: "EDIT" } & EditProps)
    | ({ type: "READ_ONLY" } & ReadOnlyProps);

function MultiMonthCheckboxes(props: MultiMonthCheckboxesProps) {
    const { labels, allLabel } = prepareLabels(i18next.language);

    switch (props.type) {
        case "EDIT": {
            const { months, onChange } = props;
            return (
                <GenericMultiCheckboxes
                    type="EDIT"
                    labels={labels}
                    allLabel={allLabel}
                    values={months}
                    onChange={onChange}
                />
            );
        }
        case "READ_ONLY": {
            const { months } = props;
            return (
                <GenericMultiCheckboxes
                    type="READ_ONLY"
                    labels={labels}
                    allLabel={allLabel}
                    values={months}
                />
            );
        }
        default: {
            return assertNever(props);
        }
    }
}

// Pass language (although it's not used explicitly) to ensure memoizeOne resets the cache
// if the language changes.
const prepareLabels = memoizeOne((_language: string) => {
    return {
        labels: {
            January: t("Month_1"),
            February: t("Month_2"),
            March: t("Month_3"),
            April: t("Month_4"),
            May: t("Month_5"),
            June: t("Month_6"),
            July: t("Month_7"),
            August: t("Month_8"),
            September: t("Month_9"),
            October: t("Month_10"),
            November: t("Month_11"),
            December: t("Month_12"),
        },
        allLabel: t("CreateControl_Recurrence_ScheduleAllMonths"),
    };
});

export { MultiMonthCheckboxes, type MultiMonthCheckboxesProps };
